module.exports = __webpack_public_path__ + "img/lc2.d946f6a5.png";